import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./calcite-form-multiselect.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./calcite-form-multiselect.component.css?ngResource";
import { ChangeDetectorRef, Component, forwardRef, Input } from "@angular/core";
import { UntypedFormBuilder, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Subject } from "rxjs";
let CalciteFormMultiselectComponent = class CalciteFormMultiselectComponent {
    formBuilder;
    changeDetectorRef;
    comboboxItemsObservable = new Subject();
    setItemsAsSelectedObservable = new Subject();
    allowCustomValues = false;
    disableComboBox = false;
    comboBoxPlaceholder = undefined;
    comboBoxScale = "s" /* ComboboxScale.small */;
    maxItems = 5;
    overlayPositioning = "absolute" /* ComboboxOverlayPositioning.absolute */;
    label = undefined;
    setSelectedItems = [];
    form;
    subscriptions = [];
    id = `${Math.random()}`;
    constructor(formBuilder, changeDetectorRef) {
        this.formBuilder = formBuilder;
        this.changeDetectorRef = changeDetectorRef;
        this.form = this.formBuilder.group({
            groups: []
        });
        this.subscriptions.push(
        // any time the inner form changes update the parent of any change
        this.form.valueChanges.subscribe(value => {
            this.onChange(value);
            this.onTouched();
        }));
    }
    get groupsControl() {
        return this.form.controls.groups;
    }
    get value() {
        return this.form.value;
    }
    set value(value) {
        this.form.setValue(value);
        this.onChange(value);
        this.onTouched();
    }
    // communicate the inner form validation-tab to the parent form
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.setSubscribers();
    }
    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
    onChange = () => {
    };
    onTouched = () => {
    };
    registerOnChange(fn) {
        this.onChange = fn;
    }
    writeValue(value) {
        if (value) {
            this.value = value;
        }
        if (value === null) {
            this.form.reset();
        }
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    validate(_) {
        return this.form.valid ? null : { groups: { valid: false } };
    }
    onSelectionChanged($event) {
        if ($event && $event.detail.selectedItems.length > 0) {
            const selectedItems = [];
            $event.detail.selectedItems.forEach((element) => {
                selectedItems.push(element.value);
            });
            this.form.get('groups')?.setValue(selectedItems);
        }
    }
    setSubscribers() {
        const comboBoxElement = document.getElementById(this.id);
        this.comboboxItemsObservable.subscribe(comboBoxItems => {
            if (comboBoxItems && comboBoxItems.length > 0) {
                comboBoxItems.forEach((comboBoxItem, i) => {
                    const id = i + 1;
                    this.setComboBoxItems(comboBoxItem, id, comboBoxElement);
                });
                this.changeDetectorRef.detectChanges();
            }
        });
        this.setItemsAsSelectedObservable.subscribe((items) => {
            if (items && items.length > 0) {
                this.setItemsAsSelected(items, comboBoxElement);
            }
        });
    }
    setComboBoxItems(comboBoxItem, elementId, comboBoxElement) {
        const comboBoxItemHTMLElement = document.createElement("calcite-combobox-item");
        comboBoxItemHTMLElement.setAttribute("id", elementId.toString());
        comboBoxItemHTMLElement.setAttribute("text-label", comboBoxItem);
        comboBoxItemHTMLElement.setAttribute("value", comboBoxItem);
        comboBoxElement?.appendChild(comboBoxItemHTMLElement);
    }
    setItemsAsSelected(selectedItems, comboBoxItemHTMLElement) {
        const comboBoxListItemNodes = comboBoxItemHTMLElement.childNodes;
        comboBoxListItemNodes.forEach((calciteNodeItem) => {
            const itemValue = calciteNodeItem?.value;
            for (const selectedItem of selectedItems) {
                if (itemValue.toLowerCase() == selectedItem.toLowerCase()) {
                    calciteNodeItem.setAttribute("selected", "true");
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: UntypedFormBuilder },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        comboboxItemsObservable: [{ type: Input }],
        setItemsAsSelectedObservable: [{ type: Input }],
        allowCustomValues: [{ type: Input }],
        disableComboBox: [{ type: Input }],
        comboBoxPlaceholder: [{ type: Input }],
        comboBoxScale: [{ type: Input }],
        maxItems: [{ type: Input }],
        overlayPositioning: [{ type: Input }],
        label: [{ type: Input }],
        setSelectedItems: [{ type: Input }]
    };
};
CalciteFormMultiselectComponent = __decorate([
    Component({
        selector: 'lib-calcite-form-multiselect',
        template: __NG_CLI_RESOURCE__0,
        providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CalciteFormMultiselectComponent),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => CalciteFormMultiselectComponent),
                multi: true
            }
        ],
        styles: [__NG_CLI_RESOURCE__1]
    })
], CalciteFormMultiselectComponent);
export { CalciteFormMultiselectComponent };
